import React, { useEffect, useState } from 'react';

import { Modal, Button, Col, Row, Form } from 'react-bootstrap';

import * as yup from 'yup';
import { useFormik } from 'formik';


import moment from 'moment';
import API from '../../common/API';

import { v4 as uuidv4 } from 'uuid';
import { parsedUser } from '../../common/GetCurrentUser';


//Validation
const validationSchema = yup.object({
    //   id: yup.string().required(),
    name: yup.string().required(),


});
//Component
const AddEditMetter = props => {
    const [state, setState] = useState({
        UI: {
            Validated: false
        },

    })
    const [currencies, setCurrencies] = useState([]);
    const [dataTaxes, setDataTaxes] = useState([]);
    const user = parsedUser();
    
    const handleSubmit = async (obj, event) => {



        console.log("values to submit", obj);

        if (obj.id.length === 0) {
            obj.id = uuidv4();
            obj.created = moment().format("YYYY-MM-DD HH:mm:ss")

            
        }
        obj.organizationid = user.organizationId;
        if (obj.identifier === null) {
            obj.identifier = uuidv4();
        }


        let request = await API.postAction(`metters/${props.mode}`, obj);

        console.log("response from adding", request);
        if (request.status === 200) {
            props.toggle(null,props.mode, true);
        }
    };
    const formik = useFormik({
        initialValues: props.model,
        validationSchema,
        onSubmit: handleSubmit,

    });

    useEffect(() => {
        setTimeout(() => {
            var focus = document.getElementsByName("name")[0];
            if (focus) {
                focus.focus();
            }
        }, 500)
    }, [])
if(!props.model){
    return(<></>)
}
    return (
        <Modal show={props.show} onHide={props.toggle} size='md' className='modalRight'>
            <Modal.Header closeButton>
                <Modal.Title>Medidor</Modal.Title>

            </Modal.Header>

            <Form onSubmit={formik.handleSubmit}>
                <Modal.Body>
                    {/* 
                LEAVE IT HERE SO WE CAN PROCCEED TO TROUBLESHOOT ANYTHING
                {Object.values(formik.errors).map((item, index)=>{
                    return(item);
                })} */}
                    <Row>
                        <Col xs={12} >
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control type="text"
                                name="name"
                                value={formik.values.name ?? ""} onChange={formik.handleChange} />
                            {formik.errors.name ? <div className="invalid text-sm">{formik.errors.name}</div> : null}
                        </Col>
                

                    </Row>

                </Modal.Body>
                <Modal.Footer className='p-1'>
                    <Button variant="primary" type="submit" className="btn-sm"
                        disabled={state.UI.isLoading}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </Form>

        </Modal>
    )
}

export default AddEditMetter;